_ = require 'underscore'
isPlainObject = require './is-plain-object'
React = require 'react'

#   _  _     ___   __   __          __   __   ___    _   _    ___     ___
#  | || |   | __|  \ \ / /    o O O \ \ / /  / _ \  | | | |  / __|   | __|
#  | __ |   | _|    \ V /    o       \ V /  | (_) | | |_| |  \__ \   | _|
#  |_||_|   |___|   _|_|_   TS__[O]  _|_|_   \___/   \___/   |___/   |___|
# _|"""""|_|"""""|_| """ | {======|_| """ |_|"""""|_|"""""|_|"""""|_|"""""|
# "`-0-0-'"`-0-0-'"`-0-0-'./o--000'"`-0-0-'"`-0-0-'"`-0-0-'"`-0-0-'"`-0-0-'
#
# Listen up. Listen good.
#
# This is an approximation of equality.
#
# As you'd expect, sometimes it's going to say things are different when
# they're really the same.
#
# As you would *not* expect, sometimes it's going to say that two things are
# the same when they're completely (well, slightly) different.
#
# This is important: this function doesn't know how to check equality on
# functions.
#
# If you start passing in different functions *anywhere* in the props, it's
# going to say "yeah that looks like it's the same," even when it isn't.
#
# To get around this, you can ensure that other properties will change when the
# function does.  For example, passing a function bound to `@`?  Make sure
# there's an `id: @id` property.
#
# Real talk: Don't use this if there's something smarter you could be doing.

module.exports = (newProps, newState) ->
  return !(areAlike(newProps, @props) && areAlike(newState, @state))

areAlike = (oldObj, newObj) ->
  if isPlainObject(oldObj) && isPlainObject(newObj)
    if _.keys(oldObj).length != _.keys(newObj).length
      return false
    for k, v of oldObj
      if !areAlike(oldObj[k], newObj[k])
        return false
  else if React.isValidElement(oldObj) && React.isValidElement(newObj)
    if !areAlike([oldObj.props, oldObj.state], [newObj.props, newObj.state])
      return false
  else if _.isArray(oldObj) && _.isArray(newObj)
    if oldObj.length != newObj.length
      return false
    for item, i in oldObj
      if !areAlike(oldObj[i], newObj[i])
        return false
  else if _.isFunction(oldObj) && _.isFunction(newObj)
    return true
  else
    if oldObj != newObj
      return false

  true



// WEBPACK FOOTER //
// ./app/scripts/lib/util/naive-should-component-update.coffee